
























































import Dialog from '@/types/Dialog.interface'
import Vue from 'vue'
import BackorderedNumberInfo from '@/components/BackorderedNumberInfo.vue'
import BroadcastFormPopup from '@/components/BroadcastFormPopup.vue'
import BroadcastPreview from '@/components/BroadcastPreview.vue'
import ChooseNumberPopup from '@/components/ChooseNumberPopup.vue'
import CreatePdf from '@/components/CreatePdf.vue'
import HostNumberInfo from '@/components/HostNumberInfo.vue'
import MediaPreview from '@/components/MediaPreview.vue'
import MessagePreview from '@/components/MessagePreview.vue'
import NewContactSelector from '@/components/NewContactSelector.vue'
import NewMessageSelector from '@/components/NewMessageSelector.vue'
import PersonsQueryFilter from '@/components/PersonsQueryFilter.vue'
import SubscriptionCancelForm from '@/components/SubscriptionCancelForm.vue'
import TemplateCenter from '@/components/TemplateCenter.vue'
import UnifiedSearch from './UnifiedSearch.vue'
import WelcomePopup from '@/components/WelcomePopup.vue'
export default Vue.extend({
    components: {
        //  Eager Imports | These are vital components that should be loaded regardless of overhead
        BackorderedNumberInfo,
        BroadcastFormPopup,
        BroadcastPreview,
        ChooseNumberPopup,
        CreatePdf,
        HostNumberInfo,
        MediaPreview,
        MessagePreview,
        NewContactSelector,
        NewMessageSelector,
        PersonsQueryFilter,
        SubscriptionCancelForm,
        TemplateCenter,
        UnifiedSearch,
        WelcomePopup,
        //  Chunk Imports | These are non-vital components that get used in multiple places, so low chance of chunks missing
        AddToGroupForm: () => import('@/components/AddToGroupForm.vue'),
        ExploreTemplates: () => import('@/components/ExploreTemplates.vue'),
        GroupRemovalForm: () => import('@/components/GroupRemovalForm.vue'),
        NewBucketForm: () => import('@/components/NewBucketForm.vue'),
        NotificationsButton: () => import('@/components/NotificationsButton.vue'),
        NewUserWelcomePopup: () => import('@/components/NewUserWelcomePopup.vue'),
        TenantCreateForm: () => import('@/components/TenantCreateForm.vue'),
        TermsOfServiceForm: () => import('@/components/TermsOfServiceForm.vue'),
        TimeZoneForm: () => import('@/components/TimeZoneForm.vue'),
        //  Group Chunk Imports | These are non-vital components that can be imported when their respective module gets loaded
        BillingSubscriptionDialog: () =>
            import(
                /* webpackChunkName: "billing-index" */ '@/components/BillingSubscriptionDialog.vue'
            ),
        BroadcastMessageTest: () =>
            import(
                /* webpackChunkName: "broadcasts" */ '@/components/BroadcastMessageTest.vue'
            ),
        CampaignForm: () =>
            import(
                /* webpackChunkName: "autoresponders" */ '@/components/CampaignForm.vue'
            ),
        CsvExportFields: () =>
            import(
                /* webpackChunkName: "csv-import" */ '@/components/CsvExportFields.vue'
            ),
        CsvImportReport: () =>
            import(
                /* webpackChunkName: "csv-import" */ '@/components/CsvImportReport.vue'
            ),
        DataProviderPopup: () =>
            import(
                /* webpackChunkName: "settings-index" */ '@/components/DataProviderPopup.vue'
            ),
        FormFieldSelector: () =>
            import(
                /* webpackChunkName: "chatbots-forms" */ '@/components/FormFieldSelector.vue'
            ),
        FormSubmission: () =>
            import(
                /* webpackChunkName: "chatbots-forms" */ '@/components/FormSubmission.vue'
            ),
        InboxFilter: () =>
            import(
                /* webpackChunkName: "inbox-components" */ '@/components/InboxFilter.vue'
            ),
        InboxSettings: () =>
            import(
                /* webpackChunkName: "settings-index" */ '@/components/InboxSettings.vue'
            ),
        InvitationsForm: () =>
            import(
                /* webpackChunkName: "teammates-index" */ '@/components/InvitationsForm.vue'
            ),
        InvoiceCampaignForm: () =>
            import(
                /* webpackChunkName: "invoice-campaigns" */ '@/components/InvoiceCampaignForm.vue'
            ),
        InvoiceForm: () =>
            import(
                /* webpackChunkName: "invoices-index" */ '@/components/InvoiceForm.vue'
            ),
        MediaForm: () =>
            import(/* webpackChunkName: "media-index" */ '@/components/MediaForm.vue'),
        MessageEditForm: () =>
            import(
                /* webpackChunkName: "messages-feed" */ '@/components/MessageEditForm.vue'
            ),
        MigrationForm: () =>
        import(
            /* webpackChunkName: "settings-index" */ '@/components/MigrationForm.vue'
        ),
        MigrationPopup: () =>
        import(
                /* webpackChunkName: "settings-index" */ '@/components/MigrationPopup.vue'
            ),
        NotificationsSettings: () =>
            import(
                /* webpackChunkName: "notifications-index" */ '@/components/NotificationsSettings.vue'
            ),
        PasswordResetByEmail: () =>
            import(
                /* webpackChunkName: "password-reset-by-email" */ '@/components/PasswordResetByEmail.vue'
            ),
        PasswordResetForm: () =>
            import(
                /* webpackChunkName: "password-reset-form" */ '@/components/PasswordResetForm.vue'
            ),
        PhoneNumbersForm: () =>
            import(
                /* webpackChunkName: "invoices-index" */ '@/components/PhoneNumbersForm.vue'
            ),
        RemoveTeammate: () =>
            import(
                /* webpackChunkName: "remove-teammate" */ '@/components/RemoveTeammate.vue'
            ),
        SetupSmsForwarding: () =>
            import(
                /* webpackChunkName: "account-index" */ '@/components/SetupSmsForwarding.vue'
            ),
        ShortLinkPopup: () =>
            import(
                /* webpackChunkName: "short-links" */ '@/components/ShortLinkPopup.vue'
            ),
        SmsNumberForm: () =>
            import(
                /* webpackChunkName: "account-index" */ '@/components/SmsNumberForm.vue'
            ),
        StripePaymentCard: () =>
            import(
                /* webpackChunkName: "stripe-billing-index" */ '@/components/StripePaymentCard.vue'
            ),
        SubscriptionCanceledConfirmation: () =>
            import(
                /* webpackChunkName: "billing" */ '@/components/SubscriptionCanceledConfirmation.vue'
            ),
        UserForm: () =>
            import(/* webpackChunkName: "teammates-index" */ '@/components/UserForm.vue'),
        VerificationForm: () =>
            import(
                /* webpackChunkName: "teammates-index" */ '@/components/VerificationForm.vue'
            ),
        WorkspaceSettings: () =>
            import(
                /* webpackChunkName: "settings-index" */ '@/components/WorkspaceSettings.vue'
            )
    },
    props: {
        //  The unique id of the component (used for multiple dialogs)
        id: {
            type: Number,
            default: null
        }
    },
    computed: {
        closeable(): boolean {
            //  If the closeable property does NOT exist, true is the default
            if (!this.dialog.hasOwnProperty('closeable')) return true

            //  Else, we return the the closeable property
            return this.dialog.closeable
        },
        dialog(): Dialog {
            return this.$store.getters.dialogApp[this.id]
        },
        cardStyle(): object {
            return {
                maxHeight: '100%',
                overflowY: this.dialog.overflow || 'auto',
                overflowX: 'hidden',
                ...this.dialog.cardStyle
            }
        }
    },
    methods: {
        close(): void {
            this.$store.dispatch('dialogClose', 'APP')
        },
        getHelp(help: string): void {
            window.open(help, '_blank')
        },
        submit(data: any): void {
            //  If a callback function is set, use it
            if (this.dialog.callback) this.dialog.callback(data)

            if (this.dialog?.closeOnSubmit) this.close()
        }
    }
})
